var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#f4f5fd"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-breadcrumb',{staticStyle:{"background-color":"#f8f9fa"},attrs:{"items":_vm.itemsBreadcrumb}}),_c('ThemeTwoDashboard')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }